import pic41 from './assets/images/41.jpg';
import pic42 from './assets/images/42.jpg';
import pic43 from './assets/images/43.jpg';
import pic44 from './assets/images/44.jpg';

import svg11 from './assets/svg/11.svg';
import svg32 from './assets/svg/32.svg';
import svg41 from './assets/svg/41.svg';
import svg43 from './assets/svg/43.svg';
import svg44 from './assets/svg/44.svg';
import svg46 from './assets/svg/46.svg';

const Four = () => (
	  <section style={{paddingTop: "1em"}}>
		<div className="section-num" style={{top: "1em"}}>8</div>
		<p><img src={pic41} alt="" /></p>
		<div className="wrapper">
			<h2>Podzemní<br />lesní internet</h2>
			<p className="like-h3" style={{marginLeft: ".75em", marginRight: ".75em"}}>Když si chtějí stromy říct něco důležitého, vypustí svými kořeny tekutiny se zprávami a živinami. Vše zachytí a vedou dál houby, které rostou na kořenech stromů. Houby prorůstají veškerou půdou v&nbsp;lese a tvoří „internetové kabely“.</p>
			<p className="txt-right">
				<span className="relative inline-block" style={{maxWidth: "16em"}}>Propojení hub a kořenů se nazývá mykorhiza a je prospěšné pro obě strany. Houby pomáhají stromům s příjmem vody a živin z půdy. Stromy jim na oplátku posílají cukry vytvořené při fotosyntéze. 
					<img src={svg41} className="pointer" style={{top: "110%", right: "0", maxWidth: "20%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic42} alt="" /></p>
		<div className="wrapper">
			<p>
				<span className="relative inline-block" style={{maxWidth: "14.5em"}}>Za provoz lesního internetu se platí. Houby si od stromu vezmou klidně třetinu cukru, kterou přes ně posílá na podporu jinému stromu. Houby ho spotřebují na vystavění svých nadzemních plodnic.
					<img src={svg32} className="pointer" style={{bottom: "100%", right: "0", maxWidth: "12%"}} alt="" />
				</span>
			</p>
			<h2>Válčící<br />stromy</h2>
			<p className="like-h3">Boj o světlo, živiny a vodu je v lese nevyhnutelný. Některé stromy si umí ukrást prostor jen samy pro sebe pomocí chemických zbraní.</p>
			<p>
				<span className="relative inline-block" style={{maxWidth: "15em"}}>Javor klen, trnovník akát nebo ořešák královský vypouští do půdy toxické látky, které znesnadňují klíčení ostatních stromů v&nbsp;jejich okolí. Tyto chemikálie se uvolňují z&nbsp;kořenů a spadaných listů.
					<img src={svg43} className="pointer" style={{top: "90%", left: "65%", maxWidth: "12%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic43} alt="" /></p>
		<div className="wrapper">
			<p className="txt-right" style={{marginTop: "-1em"}}>
				<span className="relative inline-block" style={{maxWidth: "14.8em"}}><b className="tip">Tip pro tebe:</b> Změř, kam až sahá podzemní válečná síla javoru klenu, u&nbsp;kterého stojíš. Odkrokuj si vzdálenost mezi kmenem a krajem koruny. Stejnou vzdálenost ujdi ještě jednou – až tak daleko sahá strom pod zemí. 
					<img src={svg44} className="pointer" style={{bottom: "100%", right: "70%", maxWidth: "15%"}} alt="" />
				</span>
			</p>
			<h2>Pozor<br />nebezpečí!</h2>
			<p className="like-h3">Strom cítí, když ho někdo kousne. Ze&nbsp;slin v kousanci dokáže dokonce poznat, kdo přesně ho okusuje.</p>
			<p className="txt-right">
				<span className="relative inline-block" style={{maxWidth: "12em"}}>Jako první pomoc slouží stromu pryskyřice, kterou do okousaného místa napumpuje. Pryskyřice živočicha odpudí svou hořkostí a&nbsp;lepkavostí. Zároveň se do okolí šíří její výrazná vůně.
					<img src={svg11} className="pointer" style={{top: "100%", right: "60%", maxWidth: "25%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic44} alt="" /></p>
		<div className="wrapper">
			<p>
				<span className="relative inline-block" style={{maxWidth: "14em"}}>Vůně pryskyřice je vzkaz, který ostatní&nbsp;stromy pochopí jako výstrahu před&nbsp;nebezpečím. Začnou si proto tvořit zásobu ochranné pryskyřice ještě před&nbsp;tím, než je přijde někdo okusovat.
					<img src={svg46} className="pointer" style={{bottom: "110%", right: "40%", maxWidth: "45%"}} alt="" />
				</span>
			</p>
		</div>
	</section>
);

export default Four;
